export default {
  setUploadedCsvList(state, uploadedCsvList) {
    state.uploadedCsvList = uploadedCsvList;
  },
  setBatchList(state, batchList) {
    state.batchList = batchList;
  }
};
